<div class="text-editor"
     contenteditable="true"
     [attr.placeholder]="placeholder"
     #textEditor></div>
